// Update Product price on quanity change ---------------------------------------------------------------------------------------------
$(document).ready(function () {
  $(".quantity__input").each(function () {
    const $quantityInput = $(this);
    const quantity = parseInt($quantityInput.val(), 10) || 1;
    updatePrice($quantityInput, quantity);
  });
});

function updatePrice($quantityInput, quantity) {

  const $priceElement = $quantityInput
    .closest(".product__info-container")
    .find(".get-price-data-custom-add");

  if ($priceElement.length === 0) return console.log("❌ No price element found!");

  const currencyCode = $priceElement.attr("currencycode") || "$";
  const productPrice = parseFloat($priceElement.attr("productprice"));
  const comparePrice = $priceElement.is("[comapreprice]")
    ? parseFloat($priceElement.attr("comapreprice"))
    : null;

  // Select price elements
  const $comparePriceElement = $quantityInput
    .closest(".product__info-container")
    .find(".compare-price-custom-pdp");
  const $productPriceElements = $quantityInput
    .closest(".product__info-container")
    .find(".custom-price-main-pdp");

  // Calculate new prices
  const newProductPrice = (productPrice * quantity).toFixed(2);
  const newComparePrice = comparePrice ? (comparePrice * quantity).toFixed(2) : null;

  console.log(`💲 New Price: ${newProductPrice}, Compare Price: ${newComparePrice}`);

  if ($comparePriceElement.length && newComparePrice !== null) {
    $comparePriceElement.html(`${currencyCode}${newComparePrice}`);
  }

  // $productPriceElements.each(function () {
  //   $(this).html(`${currencyCode}${newProductPrice}`);
  // });
}

 $(document).on("click", ".quantity__button", function () {
   const $button = $(this);
   const $parentContainer = $button.closest(".price-per-item__container");

   if ($parentContainer.length === 0) return;

   const $quantityInput = $button.closest(".quantity").find(".quantity__input");

   if ($quantityInput.length === 0) {
     return console.log("❌ No quantity input found!");
   }

   setTimeout(function () {
     const newQuantity = parseInt($quantityInput.val(), 10) || 1;
     console.log("🛒 Updated Quantity:", newQuantity);
     updatePrice($quantityInput, newQuantity);
   }, 50);
 });

// Watch for manual input change in quantity field
// Update price while typing, only if input is a valid number >= 1
$(document).on("input", ".quantity__input", function () {
  const $quantityInput = $(this);
  const quantity = parseInt($quantityInput.val(), 10);

  if (!isNaN(quantity) && quantity >= 1) {
    updatePrice($quantityInput, quantity);
  }
});

// On blur (when the user finishes typing), fix invalid or empty inputs
$(document).on("blur", ".quantity__input", function () {
  const $quantityInput = $(this);
  let quantity = parseInt($quantityInput.val(), 10);

  if (isNaN(quantity) || quantity < 1) {
    quantity = 1;
    $quantityInput.val(quantity); // Reset to 1
  }

  updatePrice($quantityInput, quantity);
});


 
// Update Product price on quanity change  end --------------------------------------------------------------------------------------



// personalization products js ------------------------------------------------------------------------------------------------------------

function toggleOptions(span) {
  const dropdown = span.closest(".products-list-options");
  const optionsBox = dropdown.querySelector(".list-options");
  optionsBox.style.display =
    optionsBox.style.display === "none" ? "block" : "none";
}

function selectCustomOption(optionEl, fieldName) {
  const value = optionEl.getAttribute("data-value");
  const wrapper = optionEl.closest(".products-list-options");
  // const hidden_input = dropdown.querySelector('.hidden-option');

  // Update visible text
  wrapper.querySelector(".selected-option").textContent = value;
  // Find the hidden input
  const hiddenInput = wrapper.querySelector(".hidden-option");

  console.log(fieldName);

  // Update value
  hiddenInput.value = value;

  // Hide dropdown
  wrapper.querySelector(".list-options").style.display = "none";
}

// personalization products js end -------------------------------------------------------------------------------------------------------

// product recommendation section

$(function () {
  $(".product-recommendation-section .accordion-head").click();
});

$(document).ready(function () {
  setTimeout(function () {
    $(".product-recommendation-section .accordion-head").click();
  }, 2000);

  // $('.product-recommendation-section .dropdown-info').show();
  // $('.product-recommendation-section .plus-minus-icon').removeClass('close').addClass('open');

  // $('.product-recommendation-section .plus-minus-icon').trigger();

  var peopleAlsoBought = $(".related-products");
  var desktopContainer = $(".you-may-also");
  var mobileContainer = $(".you-may-also-mobile");

  var alsoboughtApp = $(".cbb-also-bought-container");

  var alsobought = $(".also-bought-section");

  $(".dropdown-info").hide();
  $(document).on("click", ".accordion-head", function () {
    if ($(this).find(".plus-minus-icon").hasClass("close")) {
      // $('.plus-minus-icon').removeClass('open').addClass('close');
      $(this).find(".plus-minus-icon").removeClass("close").addClass("open");
    } else if ($(this).find(".plus-minus-icon").hasClass("open")) {
      $(this).find(".plus-minus-icon").removeClass("open").addClass("close");
    }

    $(this).next(".dropdown-info").toggle();

    if (desktopContainer.length) {
      $(this).next(".dropdown-info").find(".related-products").show();
    }
  });

  setTimeout(function () {
    if (peopleAlsoBought.length) {
      if (desktopContainer.length) {
        desktopContainer.append(peopleAlsoBought.clone()); // Clone for desktop

        // initializeSwiper();
      }
      if (mobileContainer.length) {
        mobileContainer.append(peopleAlsoBought.clone()); // Clone for mobile
      }
    }


    if (alsoboughtApp.length) {
      if (alsobought.length) {
        alsobought.append(alsoboughtApp.clone()); // Clone for desktop

        // initializeSwiper();
      }
  
    }


    
  }, 1000);
});



window.initializeSwiper = function () {
  new Swiper(".swiper-container22", {
    loop: false,
    slidesPerView: 5, // Show 4 slides at a time
    slidesPerGroup: 4, // Scroll 4 slides at a time
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    // scrollbar: {
    //    el: ".bought-scrollbar",
    //    draggable: true,
    //    dragSize: 200,
    //  },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    // autoplay: {
    //   delay: 3000,
    //   disableOnInteraction: false,
    // },
    breakpoints: {
      320: { slidesPerView: 2, slidesPerGroup: 2 },
      686: { slidesPerView: 5, slidesPerGroup: 5 },
    },
  });
};

// Call the function when the page loads
document.addEventListener("DOMContentLoaded", function () {
  window.initializeSwiper();
});



// text changes search functionality
document.addEventListener("DOMContentLoaded", function () {
  const searchLabel = document.querySelector(".text-changed-search");

  // Placeholder texts to cycle through
  const placeholders = [
    "Arrow Carport",
    "Ceiling Support Box",
    "Wind And Snow Rated",
    "Storm Collar",
    "Thimble",
    "Chimney Caps",
  ];

  let index = 0; // Tracks which word is being typed
  let charIndex = 0; // Tracks character position
  let isDeleting = false; // Typing forward or deleting backward
  let speed = 50; // Typing speed

  function typeEffect() {
    if (!searchLabel) return; // Ensure the element exists

    let currentText = placeholders[index];
    let displayText = currentText.substring(0, charIndex);
    searchLabel.textContent = displayText; // Update label text

    if (!isDeleting) {
      charIndex++;
      if (charIndex > currentText.length) {
        isDeleting = true;
        speed = 1000; // Pause before deleting
      }
    } else {
      charIndex--;
      speed = 100; // Speed up deleting
      if (charIndex === 0) {
        isDeleting = false;
        index = (index + 1) % placeholders.length; // Move to next word
        speed = 200; // Pause before typing new word
      }
    }

    setTimeout(typeEffect, speed);
  }

  typeEffect(); // Start animation
});

document.addEventListener("DOMContentLoaded", function () {
  const searchLabel = document.querySelector(".text-changed-search2");

  // Placeholder texts to cycle through
  const placeholders = [
    "Arrow Carport",
    "Ceiling Support Box",
    "Wind And Snow Rated",
    "Storm Collar",
    "Thimble",
    "Chimney Caps",
  ];

  let index = 0; // Tracks which word is being typed
  let charIndex = 0; // Tracks character position
  let isDeleting = false; // Typing forward or deleting backward
  let speed = 50; // Typing speed

  function typeEffect() {
    if (!searchLabel) return; // Ensure the element exists

    let currentText = placeholders[index];
    let displayText = currentText.substring(0, charIndex);
    searchLabel.textContent = displayText; // Update label text

    if (!isDeleting) {
      charIndex++;
      if (charIndex > currentText.length) {
        isDeleting = true;
        speed = 1000; // Pause before deleting
      }
    } else {
      charIndex--;
      speed = 100; // Speed up deleting
      if (charIndex === 0) {
        isDeleting = false;
        index = (index + 1) % placeholders.length; // Move to next word
        speed = 200; // Pause before typing new word
      }
    }

    setTimeout(typeEffect, speed);
  }

  typeEffect(); // Start animation
});

// end text changes search functionality

//cart add to cart start functionality

function setHeaderCartIconAccessibility() {
  const cartLink = document.querySelector("#cart-icon-bubble");
  if (!cartLink) return;

  // Expose the openCart function globally
  window.openCart = function () {
    console.log("Opening the cart...");
    // Replace `this.open` with your cart opening logic here
    // For example:
    cartLink.click();
    setTimeout(function () {
      $("cart-drawer").removeClass("is-empty");
    }, 800); // 2000 milliseconds = 2 seconds
  };

  console.log(
    "Cart open function is available. Use 'openCart()' in the console to open the cart."
  );
}

// Call the function to initialize
setHeaderCartIconAccessibility();

//  $(document).on("click", "button#predictive_atc", function() {
//     var variantId = $(this).data('id');
//     $.ajax({
//       type: 'POST',
//       url: '/cart/add.js',
//       data: {
//         quantity: 1,
//         id: variantId
//       },
//       dataType: 'json',
//       success: function(cart) {
//        $('#CartDrawer .drawer__inner').load(location.href + ' #CartDrawer .drawer__inner > *');

//        openCart();

//         $('.cart-count-bubble').load(location.href + ' .cart-count-bubble > *');

// $("cart-drawer").removeClass("is-empty");

//       },
//       error: function(xhr, status, error) {
//         console.error("Error adding product to cart:", error);
//       }
//     });
//   });

$(document).on("click", "#predictive_atc", function () {
  var $button = $(this);
  var variantId = $button.data("id");

  // Hide 'Add To Cart' text and show loading spinner
  // $button.find('.atc-text').hide();
  $button.find(".loading__spinner").removeClass("hidden");

  // Wait for 2 seconds before sending the AJAX request
  setTimeout(function () {
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        quantity: 1,
        id: variantId,
      },
      dataType: "json",
      success: function (cart) {
        $("#CartDrawer .drawer__inner").load(
          location.href + " #CartDrawer .drawer__inner > *"
        );
        openCart();
        $(".cart-count-bubble").load(location.href + " .cart-count-bubble > *");
        $("cart-drawer").removeClass("is-empty");
      },
      error: function (xhr, status, error) {
        console.error("Error adding product to cart:", error);
      },
      complete: function () {
        // Show 'Add To Cart' text and hide loading spinner after request is complete
        $button.find(".atc-text").show();
        $button.find(".loading__spinner").addClass("hidden");
      },
    });
  }, 100); // 2-second delay before sending the AJAX request
});

// close add to cart functionality

// change upc code
document.addEventListener("DOMContentLoaded", function () {
  const upcDiv = document.querySelector(".custom-upc");

  function updateUPC() {
    const barcodeElement = document.querySelector('[id^="barcode-"]');
    if (barcodeElement && upcDiv) {
      const barcodeValue = barcodeElement.textContent.trim();
      upcDiv.textContent = "UPC: " + barcodeValue;
    }
  }

  // Initial update
  updateUPC();

  // Listen for variant change
  document.body.addEventListener("change", function (e) {
    // Variant dropdown/select or radio inputs may trigger change
    if (e.target.name === "id") {
      // Delay to allow DOM update (Shopify updates content slightly after)
      setTimeout(updateUPC, 100);
    }
  });
});
// end upc code

// $(document).ready(function () {
//   $(document).on("click", ".clear-cart-button", function () {
//     $.ajax({
//       type: 'POST',
//       url: '/cart/clear.js',
//       success: function () {
//         console.log("Cart cleared");
//         $('#CartDrawer .drawer__inner').load(location.href + ' #CartDrawer .drawer__inner > *');
//         $('.cart-count-bubble').load(location.href + ' .cart-count-bubble > *');
//         $('.upsell-container').hide();
//         $('.drawer__footer').hide();
//         $("cart-drawer").addClass("is-empty");
//       },
//       error: function (xhr, status, error) {
//         console.error("Error clearing cart:", error);
//       }
//     });
//   });
// });

$(document).on("click", ".remove-all-cart-page-items", function () {
  // POST to Shopify's cart clear endpoint
  fetch("/cart/clear.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then(function () {
      location.reload();
    })
    .catch(function (error) {
      console.error("Error clearing cart:", error);
    });
});

// Clear all Button Fucntionality

$(document).on("click", ".clear-cart-button", function () {
 $(this).find('.custom-clear-text').text('Clearing...');
  $.ajax({
    type: "POST",
    url: "/cart/clear.js",
    dataType: "json",
    success: function () {
      if ($('.template-location-cart').length > 0) {
        window.location.href = "/cart";
      } else {

      $(".drawer__inner").load("/cart .drawer__inner > *", function () {
        $(".drawer").addClass("is-empty");
         $(".cart-count-bubble").load(location.href + " .cart-count-bubble > *");
        window.initializeCartAddOnSwiper();
      });

    }
    },
    error: function () {
      alert("Oops! Couldn’t clear cart. Please try again.");
    }
  });
});


// Clear all Button Fucntionality

//  document.addEventListener('DOMContentLoaded', function () {
//     // Find the submenu <ul> under the Firewood Storage & Handling <li>
//     const firewoodMenu = document.querySelector('.mega-menu__link--level-2');
//     if (firewoodMenu) {
//       const parentLi = firewoodMenu.closest('li');
//       const submenu = parentLi.querySelector('ul');

//       if (submenu) {
//         const itemCount = submenu.querySelectorAll('li').length;

//         if (itemCount > 8) {
//           // Add a class to the parent <li> (or change as needed)
//           parentLi.classList.add('has-many-subitems');
//         }
//       }
//     }
// });

// mega menu
document.addEventListener("DOMContentLoaded", function () {
  // Find all level-2 links
  const level2Links = document.querySelectorAll(".mega-menu__link--level-2");

  level2Links.forEach((link) => {
    // Trim text content and check if it's the "Firewood Storage & Handling" menu
    // if (link.textContent.trim() === 'Firewood Storage & Handling') {
    const parentLi = link.closest("li");
    const submenu = parentLi.querySelector("ul");

    if (submenu) {
      const itemCount = submenu.querySelectorAll("li").length;

      if (itemCount > 8) {
        parentLi.classList.add("has-many-subitems");
      }
    }
    // }
  });
});

// article-template-pages
$(".article-template table").each(function () {
  $(this).wrap('<div class="table-responsive"></div>');
});

// bundle product
$(document).ready(function () {
  const classToAddMain = "dropdown-active";
  const classToAdd = "dropdown-open";

  $(".bundle--products .custom-dropdown .dropdown-selected").on(
    "click",
    function (e) {
      e.stopPropagation(); // prevent immediate removal

      $(".bundle--products .custom-dropdown .dropdown-selected").removeClass(
        classToAddMain
      );
      $(".bundle--products .custom-dropdown ul").removeClass(classToAdd);

      $(".dropdown-content").toggleClass(classToAdd); // optional: close others
      $(this).next("ul").toggleClass(classToAdd);
      $(this).toggleClass(classToAddMain);
    }
  );

  $(document).on("click", function (e) {
    if (!$(e.target).closest(".custom-dropdown").length) {
      $(".bundle--products .custom-dropdown .dropdown-selected").removeClass(
        classToAddMain
      );
      $(".bundle--products .custom-dropdown ul").removeClass(classToAdd);
    }
  });
});






// add on slider code 
function initializeSwiperSlider(containerSelector) {
  // Check if Swiper is already initialized
  if (document.querySelector(containerSelector)) {
    const container = document.querySelector(containerSelector);

    // Destroy existing Swiper instance if it exists
    if (container.swiper) {
      container.swiper.destroy(true, true);
    }

    // Initialize Swiper
    const swiper = new Swiper(containerSelector, {
      slidesPerView: 1.5, // Adjust based on layout
      spaceBetween: 10, // Spacing between slides
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },

      breakpoints: {
        1024: {
          slidesPerView: 1.5,
        },
        768: {
          slidesPerView: 1.5,
        },
        480: {
          slidesPerView: 1.5,
        },
      },
      loop: false, // Infinite loop scrolling
    });

    console.log("Swiper initialized:", swiper);
    return swiper; // Return the Swiper instance if needed
  }
}

// Initialize the slider on page load
document.addEventListener("DOMContentLoaded", () => {
  initializeSwiperSlider(".swiper-container.collection-slider");
});



$(document).on("click", ".addon-cart", function () {
var $button = $(this);
  $button.addClass("is-loading");
  var variantId = $button.data("id");

  // Change button text to "Adding..."
  $button.prop("disabled", true);

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: {
      quantity: 1,
      id: variantId,
    },
    dataType: "json",
    success: function (cart) {
      // Load cart drawer content
      $("#CartDrawer .drawer__inner").load(
        location.href + " #CartDrawer .drawer__inner > *",
        function () {
          // Initialize Swiper slider once the drawer content is fully loaded
            $button.removeClass("is-loading");
          initializeSwiperSlider(".swiper-container.collection-slider");
        }
      );

      // Open the cart drawer
      // Update cart count bubble
      $(".cart-count-bubble").load(location.href + " .cart-count-bubble > *");

      // Remove "is-empty" class from the cart drawer
      // Revert button text to the original and enable it
      $button.prop("disabled", false);
    },
    error: function (xhr, status, error) {
      console.error("Error adding product to cart:", error);
 $button.removeClass("is-loading");

      // Revert button text to the original and enable it even on error
      $button.text(originalText).prop("disabled", false);
    },
  });
});













// cart page recommended 



function initializeRecommendedcartpageSwiper() {
  var cartAddonSwiper = new Swiper(".swiper-cart-page-recommended", {
    slidesPerView: 2, // Adjust based on your design
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next-cart-recommended",
      prevEl: ".swiper-button-prev-cart-recommended",
    },
    scrollbar: {
      el: ".swiper-pagination-cart-page-recommended",
      draggable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
      1024: {
        slidesPerView: 6,
        spaceBetween: 20,
      },
    },
  });
}




// You can call initializeCartAddonSwiper() again later as needed.


  function refreshRecommendations() {

  
    
    const recommendationsSection = document.querySelector("product-recommendations-cartpage");
        const recommendationsSection2 = document.querySelector(" .custom-tbody-cart-page");
   

    if (!recommendationsSection) return;

    const productId = recommendationsSection2.getAttribute("product-id");
    const sectionId = recommendationsSection.getAttribute("section-id");

    const recommendationsUrl =
      window.themeVariables?.routes?.productRecommendationsUrl ||
      "/recommendations/products";

    fetch(
      `${recommendationsUrl}?product_id=${productId}&limit=10&section_id=${sectionId}`
    )
      .then((response) => response.text())
      .then((html) => {
        const div = document.createElement("div");
        div.innerHTML = html;
        const newRecommendations = div.querySelector("product-recommendations-cartpage");

        if (newRecommendations && newRecommendations.innerHTML.trim()) {
          recommendationsSection.innerHTML = newRecommendations.innerHTML;
          recommendationsSection.hidden = false;
        } else {
          recommendationsSection.hidden = true;
        }
initializeRecommendedcartpageSwiper();

     
      })
      .catch((error) =>
        console.error("Error fetching recommendations:", error)
      );
  }

  document.addEventListener("DOMContentLoaded", refreshRecommendations);

// cart page recommended end 
